<template>
  <canvas
    class="blog-avatar img-fluid"
    ref="canvas"
    :width="w"
    :height="h"
    :title="blog.title"
    @click.prevent="openBlog(blog)"
  ></canvas>
</template>

<script>

    import AvatarCreator from '../../services/AvatarCreator';

    export default {
            props: {
                blog: {type: Object},
                w: {type: Number},
                h: {type: Number},
            },
            data() {
                return {
                    cr: null,
                    cache: null
                }
            },

            mounted(){
                this.cr = new AvatarCreator(this.$refs['canvas']);
                if(this.blog._id)this.cr.render(this.blog._id)
            },
            watch:{
                blog(newBlog, oldBlog){
                    if(newBlog._id != oldBlog._id){
                        this.cr.render(this.blog._id)
                    }
                }
            },
            methods: {
              render(string){
                this.cr.render(string)
              },
              openBlog(blog){
                this.$bus.$emit('blog-modal.open', {blog});
              },
              getBlogUrl(blog){
                return this.$router.resolve({name: 'BlogPage', params:{blogUrl:blog.url}}).href;
              },
            }

    }
</script>

<style lang="sass">
    .blog-avatar
        border-style: none
        vertical-align: middle

</style>



// WEBPACK FOOTER //
// src/components/ui/BlogAvatar.vue